import { DEFAULT_TENANT } from '@constants'
import enMessages from './apps/tribe/locales/en.json'

// Eager glob of every locale JSON. Replaces the dynamic `require()` used to
// load per-tenant overrides under webpack (Vite/Rollup cannot do runtime require).
const localeFiles = import.meta.glob('./apps/*/locales/*.json', {
  eager: true,
  import: 'default',
}) as Record<string, Record<string, string>>

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    BRAND_APP_LOCALE_OVERRIDE: Record<string, string>
  }
}

let messages = enMessages

if (process.env.APP_NAME && process.env.APP_NAME !== DEFAULT_TENANT) {
  const app = process.env.APP_NAME === '__APP_NAME__' ? DEFAULT_TENANT : process.env.APP_NAME
  const overrides = localeFiles[`./apps/${app}/locales/en.json`]
  if (overrides) {
    messages = {
      ...messages,
      ...overrides,
    }
  }
}

if (window.BRAND_APP_LOCALE_OVERRIDE) {
  messages = { ...messages, ...window.BRAND_APP_LOCALE_OVERRIDE }
}

export default messages
